import React from "react";
import { isFunction } from "lodash";
import { SearchComponentWithApi } from "./SearchComponentWithApi";
import { isValidArray } from "../helper";
import { FormGroup } from "react-bootstrap";

const style = {
  optionsParent: {
    position: "absolute",
    top: "100%",
    zIndex: "100",
    maxHeight: "89px",
    overflow: "auto",
    background: "#ffff",
    borderRadius: "4px",
    width: "100%"
  },
  optionsChildIssue: {
    position: "absolute",
    overflow: "auto",
    width: "100%"
  },
  options: {
    display: "block",
    padding: "15px",
    borderBottom: "1px solid #efecec",
    fontSize: "11px",
    cursor: "pointer"
  }
};

export class AutoSuggestSelect extends React.Component {
  oldOptions = [];

  state = {
    selectedOption: null,
    optionsValue: "",
    options: []
  };

  componentDidMount() {
    window.document.addEventListener("click", this.showDropdown);
  }

  componentWillUnmount() {
    window.document.removeEventListener("click", this.showDropdown);
  }

  showDropdown = event => {
    const { id = "search-api-element", index } = this.props;
    let show = false;
    let _searchTerm = index
      ? `search-api-element-${index}`
      : "search-api-element";
    if (event.target.getAttribute("id") === _searchTerm) {
      show = true;
    }
    this.setState({
      showOptions: show
    });
  };

  onChange = (value, key) => {
    const { onChange } = this.props;
    this.setState({ showOptions: true });
    onChange(value);
  };

  onBlur = value => {
    const { onBlur } = this.props;
    onBlur(value);
  };
  OtherPPBlur = value => {
    const { OtherPPBlur } = this.props;
    OtherPPBlur(value);
  };
  onOptionClick = value => {
    const { onOptionClick } = this.props;
    onOptionClick(value);
  };
  valueDisplay = value => {
    const {
      isStateDepartment,
      isStatePMG,
      StateDepartmentissuePage,
      StatePMGissuePage
    } = this.props;
    if (isStateDepartment || isStatePMG) {
      return value.organization && `(${value.organization})`;
    } else if (StateDepartmentissuePage || StatePMGissuePage) {
      return value.organizationGroup && `(${value.organizationGroup})`;
    } else {
      return value.userID && `(${value.userID})`;
    }
  };
  border() {
    const { redBorder, isInvalid, additionalPP, error } = this.props;
    if (!redBorder) {
      return "1px solid #acacac";
    } else if (redBorder && redBorder != "invalid") {
      return "none";
    } else if (redBorder == "invalid" && !isInvalid) {
      return "1px solid #fc192e";
    } else if (redBorder == "invalid" && isInvalid) {
      return "none";
    }
  }
  borderForOtherPP() {
    const { additionalPP, error } = this.props;
    if (additionalPP && error) {
      return "1px solid #fc192e";
    }
  }
  render() {
    const {
      name,
      options,
      defaultSelected,
      isLoading,
      value,
      delay,
      disabled,
      id = "search-api-element",
      index,
      childIssue,
      isInvalid = false,
      isEditUserSearch,
      isCreateUserSearch,
      isMinistry,
      isStateDepartment,
      isStatePMG,
      redBorder,
      additionalPP,
      error
    } = this.props;
    const { optionsValue, showOptions } = this.state;
    return (
      <React.Fragment>
        <div
          class="form-field"
          style={{
            position: "relative",
            width: "100%",
            border: additionalPP ? this.borderForOtherPP() : this.border()
          }}
          ref={element => {
            this.searchComponent = element;
          }}
        >
          <SearchComponentWithApi
            isLoading={isLoading}
            onChange={this.onChange}
            list={name}
            value={defaultSelected}
            isMinistry={isMinistry === true}
            style={{
              padding: "0px 15px",
              backgroundColor:
                isInvalid || redBorder == "invalid" || (additionalPP && error)
                  ? "#fef4f4"
                  : "",
              border: isInvalid ? "1px solid #fc192e" : ""
            }}
            className={
              isCreateUserSearch || isEditUserSearch ? "search-component" : ""
            }
            onClick={this.onClick}
            id={id}
            index={index}
            name="random-name"
            delay={delay}
            disabled={disabled}
            onBlur={this.onBlur}
            OtherPPBlur={this.OtherPPBlur}
            additionalPP={additionalPP}
          />
          {(isValidArray(options) && (
            <div
              style={
                childIssue === true
                  ? style.optionsChildIssue
                  : style.optionsParent
              }
            >
              {showOptions &&
                !disabled &&
                options.map(value => {
                  return (
                    <div
                      data-test="search-field"
                      style={style.options}
                      onClick={() => {
                        this.onOptionClick(value);
                      }}
                    >
                      {value.name} {this.valueDisplay(value)}
                    </div>
                  );
                })}
            </div>
          )) ||
            null}
        </div>
      </React.Fragment>
    );
  }
}
